export default __webpack_public_path__ + "static/media/opa_savings.93efdb39.svg";